// extracted by mini-css-extract-plugin
export default {"loader":"zLTUV","spinner":"lAifx","rotate-ltr":"wQpQa","rotateLtr":"wQpQa","rotate-rtl":"p58Fm","rotateRtl":"p58Fm","path":"mWCpr","dash":"E6IlZ"};